import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const GroupEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [groupname, setgroupname] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchgroupData = async () => {
      try {
        const response = await axios.get(BASE_URL + "productGroup/findById/" + id, {
          headers: authHeader(),
        });
        setgroupname(response.data.groupname);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch group data. Please try again.',
        });
      }
    };

    fetchgroupData();
  }, [id]);

  const validateForm = () => {
    if (!groupname) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please enter a group name.',
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);

    const groupData = {
      groupname: groupname,
    };

    try {
      await axios.put(`${BASE_URL}productGroup/update/${id}`, groupData, {
        headers: authHeader(),
      });
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Group added successfully!',
      });
      navigate("/groupindex/1");
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD GROUP</h6>
          <Link to="/groupindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formgroupname">
                  <Form.Label>Group Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Group name"
                    value={groupname}
                    onChange={(e) => setgroupname(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GroupEdit;